import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  BrowserRouter as Router, Switch, Redirect, Route
} from 'react-router-dom'
import Drift from 'react-driftjs'
import StartupActions from 'Redux/StartupRedux'
import GaTracking from 'Components/GaTracking'
import SmartLookClient from 'Components/SmartLookClient'
import AuthLayout from './Pages/Layouts/Auth'
import DashboardLayout from './Pages/Layouts/Dashboard'
import NavBarOnlyLayout from './Pages/Layouts/NavBarOnly'
import NotFound from './Pages/Layouts/NotFound'
import UsersList from './Pages/Users/List'
import TeamsList from './Pages/Teams/List'
import UserAddEdit from './Pages/Users/AddEdit'
import Settings from './Pages/Settings'
import Home from './Pages/Home/Home'
import VideosSingle from './Pages/Videos/Single'
import Signup from './Pages/Auth/Signup'
import Login from './Pages/Auth/Login'
import ForgotPassword from './Pages/Auth/ForgotPassword'
import ResetPassword from './Pages/Auth/ResetPassword'
import Plans from './Pages/Subscription/Plans'
import Activities from './Pages/Activities/List'
import DebugConfig from 'Config/DebugConfig'

class AppRouter extends Component {
  constructor (props) {
    super(props)
    this.props.startup()
  }

  render () {
    return (
      <React.Fragment>
        { !DebugConfig.isDev && this.props.userData &&
          <Drift appId='ikbetbiyksav'
            userId={this.props.userData.id}
            attributes={{
              email: this.props.userData.uid
            }}
          />
        }
        {
          !DebugConfig.isDev && <SmartLookClient />
        }
        <Router>
          <React.Fragment>
            <Switch>
              <AuthLayout
                exact
                path='/auth/signup'
                component={Signup} />
              <AuthLayout
                exact
                path='/auth/login'
                component={Login}
                layoutTitle='Login' />
              <AuthLayout
                exact
                path='/auth/login/:redirectTo'
                component={Login}
                layoutTitle='Login' />
              <AuthLayout
                exact
                path='/auth/forgot'
                component={ForgotPassword}
                layoutTitle='Forgot Password' />
              <AuthLayout
                exact
                path='/auth/reset'
                component={ResetPassword}
                layoutTitle='Reset Password' />
              <AuthLayout
                exact
                path='/auth/reset/:projectId'
                component={ResetPassword}
                layoutTitle='Reset Password' />
              <NavBarOnlyLayout
                exact
                path='/teams'
                component={TeamsList} />
              <NavBarOnlyLayout
                exact
                path='/teams/:teamId/users'
                component={UsersList} />
              <NavBarOnlyLayout
                exact
                path='/teams/:teamId/users/new'
                component={UserAddEdit} />
              <NavBarOnlyLayout
                exact
                path='/teams/:teamId/users/:userId'
                component={UserAddEdit} />
              <DashboardLayout
                exact
                path='/projects'
                component={Home} />
              <NavBarOnlyLayout
                path='/teams/:teamId/subscription'
                component={Plans} />
              <NavBarOnlyLayout
                path='/settings'
                component={Settings} />
              <DashboardLayout
                path='/projects/:projectId'
                component={Home} />
              <NavBarOnlyLayout
                exact
                path='/videos/:videoId'
                component={VideosSingle} />
              <NavBarOnlyLayout
                exact
                path='/activities'
                component={Activities} />
              <Redirect from='/' exact to='/projects' />
              <Route component={NotFound} />
            </Switch>
            <GaTracking />
          </React.Fragment>
        </Router>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  startup: _ => dispatch(StartupActions.startup())
})

const mapStateToProps = (state) => ({
  userData: state.auth.userData
})

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter)



// WEBPACK FOOTER //
// ./src/Router.js